/* ══════════════════════════════════════════════════
   CarVerif — Code Défaut v3.0 — Modern Interactions
   Sticky navigation, accessible tabs, and conversion controls
   ══════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ══════════════════════════════════════
     Header height detection + CSS variable
     ══════════════════════════════════════ */
  var cdPage = document.querySelector('.cd-page');
  var header = document.querySelector('sticky-header, .section-header, .shopify-section-group-header-group');
  var stickyOffset = 48;

  /* ══════════════════════════════════════
     Sticky tabs — active state tracking
     ══════════════════════════════════════ */
  var tabs = document.querySelectorAll('.cd-tab[data-tab]');
  var tabBar = document.getElementById('cdTabs');
  var tabSections = [];
  tabs.forEach(function(tab) {
    var id = tab.getAttribute('href');
    var el = document.querySelector(id);
    if (el) tabSections.push({ tab: tab, el: el });
  });

  function measureLayout() {
    var headerHeight = header ? header.offsetHeight : 0;
    stickyOffset = headerHeight + (tabBar ? tabBar.offsetHeight : 48);
    if (cdPage) cdPage.style.setProperty('--cd-header-h', headerHeight + 'px');
    tabSections.forEach(function(s) { s.top = s.el.offsetTop; });
  }

  function getStickyOffset() {
    return stickyOffset;
  }

  function updateTabs() {
    var current = tabSections[0];
    var scrollY = window.scrollY + getStickyOffset() + 20;
    tabSections.forEach(function(s) {
      if (s.top <= scrollY) current = s;
    });
    tabs.forEach(function(t) { t.classList.remove('cd-tab-active'); });
    if (current) current.tab.classList.add('cd-tab-active');
  }

  var tabTick = false;
  window.addEventListener('scroll', function() {
    if (!tabTick) {
      requestAnimationFrame(function() {
        updateTabs();
        updateStickyCta();
        tabTick = false;
      });
      tabTick = true;
    }
  }, { passive: true });

  measureLayout();
  updateTabs();
  window.addEventListener('load', measureLayout, { once: true });
  window.addEventListener('resize', measureLayout, { passive: true });

  /* ══════════════════════════════════════
     Smooth scroll for tabs + TOC
     ══════════════════════════════════════ */
  var tabsScrollEl = document.getElementById('cdTabsScroll');

  function centerTab(tab) {
    if (!tabsScrollEl) return;
    var scrollLeft = tab.offsetLeft - (tabsScrollEl.clientWidth / 2) + (tab.offsetWidth / 2);
    tabsScrollEl.scrollTo({ left: scrollLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  }

  document.querySelectorAll('.cd-tab[data-tab], .cd-toc-item').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var self = this;
      var target = document.querySelector(self.getAttribute('href'));
      if (target) {
        var offset = getStickyOffset() + 8;
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        if (self.classList.contains('cd-tab')) {
          centerTab(self);
        }
      }
    });
  });

  /* ══════════════════════════════════════
     Tab overflow fade indicator
     ══════════════════════════════════════ */
  var tabsScroll = document.getElementById('cdTabsScroll');
  var tabsFade = document.getElementById('cdTabsFade');
  if (tabsScroll && tabsFade) {
    function checkTabOverflow() {
      var hasOverflow = tabsScroll.scrollWidth > tabsScroll.clientWidth;
      var atEnd = tabsScroll.scrollLeft + tabsScroll.clientWidth >= tabsScroll.scrollWidth - 2;
      if (hasOverflow && !atEnd) {
        tabsFade.classList.add('cd-visible');
      } else {
        tabsFade.classList.remove('cd-visible');
      }
    }
    var overflowTick = false;
    function scheduleOverflowCheck() {
      if (overflowTick) return;
      overflowTick = true;
      requestAnimationFrame(function() {
        checkTabOverflow();
        overflowTick = false;
      });
    }
    tabsScroll.addEventListener('scroll', scheduleOverflowCheck, { passive: true });
    window.addEventListener('resize', scheduleOverflowCheck, { passive: true });
    checkTabOverflow();
  }

  /* ══════════════════════════════════════
     CTA sticky — show/hide + close button
     ══════════════════════════════════════ */
  var cta = document.getElementById('cdCtaSticky');
  var ctaClose = document.getElementById('cdCtaClose');
  var ctaDismissed = false;

  function updateStickyCta() {
    if (!cta || ctaDismissed) return;
    cta.classList.toggle('cd-cta-visible', window.scrollY > 600);
  }

  updateStickyCta();

  if (ctaClose) {
    ctaClose.addEventListener('click', function() {
      ctaDismissed = true;
      cta.classList.remove('cd-cta-visible');
      cta.classList.add('cd-cta-dismissed');
    });
  }

});
